import { useState, useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIIcon from 'UIComponents/icon/UIIcon';
import { EERIE } from 'HubStyleTokens/colors';
import { fetchPipelines } from '../../api/pipelinesApi';
import { derivePipelineNames } from '../../utils/pipelineUtils';
import Links from '../../constants/Links';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DealSidebarOverviewPipelineHelpText = ({
  assigneeType,
  hasAllPipelinesGoal,
  hasGoal,
  isTeam,
  pipelines
}) => {
  const [pipelinesSize, setPipelinesSize] = useState(0);
  const [singlePipelineLabel, setSinglePipelineLabel] = useState('');
  const noExplicitTeamGoal = assigneeType === 'OWNER' && isTeam;
  useEffect(() => {
    fetchPipelines().then(results => {
      setPipelinesSize(results.length);
      const allPipelineNames = derivePipelineNames(results);
      setSinglePipelineLabel(allPipelineNames[pipelines.get(0)]);
    }).catch(() => {
      setPipelinesSize(0);
    });
  }, [setPipelinesSize, pipelinesSize, setSinglePipelineLabel, pipelines]);
  let PipelineHelpTextMessage = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dealSidebar.goalsForSelectedPipelinesSubtext"
  });
  let tooltipTitle = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dealSidebar.goalsTooltip.tooltipHeader"
  });
  let tooltipMessage = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dealSidebar.goalsTooltip.tooltipMessage"
  });
  let showTooltip = true;
  if (!hasGoal) {
    tooltipMessage = /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "dealSidebar.goalsTooltip.noGoalsSetTooltipMessage_jsx",
      elements: {
        Link
      },
      options: {
        href: Links.GOALS_CREATION
      }
    });
    if (pipelines.size === 1) {
      PipelineHelpTextMessage = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dealSidebar.goalsTooltip.noGoalSetTooltipHeader"
      });
      tooltipTitle = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dealSidebar.goalsTooltip.noGoalSetTooltipHeader"
      });
    } else {
      tooltipTitle = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dealSidebar.goalsTooltip.noGoalsTooltipHeader"
      });
    }
  } else if (noExplicitTeamGoal) {
    tooltipTitle = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dealSidebar.goalsTooltip.noTeamGoalTooltipHeader"
    });
    PipelineHelpTextMessage = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dealSidebar.repGoalsForPipelinesSubtext"
    });
    tooltipMessage = /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "dealSidebar.goalsTooltip.noGoalsSetTooltipMessage_jsx",
      elements: {
        Link
      },
      options: {
        href: Links.GOALS_CREATION
      }
    });
  } else if (pipelines.size === 1) {
    PipelineHelpTextMessage = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dealSidebar.goalsForSinglePipelineSubtext",
      options: {
        pipeline: singlePipelineLabel
      }
    });
    showTooltip = false;
  } else if (pipelines.size === pipelinesSize && hasAllPipelinesGoal) {
    PipelineHelpTextMessage = /*#__PURE__*/_jsx(View, {
      marginInlineStart: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dealSidebar.goalsForAllPipelinesSubtext"
      })
    });
    showTooltip = false;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "stretch",
    children: [/*#__PURE__*/_jsx(View, {
      marginInlineStart: "200",
      "data-test-id": "goals-panel-overview-help-text",
      children: PipelineHelpTextMessage
    }), showTooltip && /*#__PURE__*/_jsx(UITooltip, {
      headingText: tooltipTitle,
      title: tooltipMessage,
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "info",
        color: EERIE,
        className: "m-left-1",
        "data-test-id": "info-icon"
      })
    })]
  });
};